module.exports = __webpack_public_path__ + "img/status_1.cb82a00d.png";